
import React, { Fragment, useState } from 'react'
import { Button, Dropdown, ListGroup, Modal } from 'react-bootstrap'
import { useSelector } from 'react-redux'

import { useProgrammation } from '../../../Hooks/UseProgrammation'
import useTranslation from '../../../Hooks/UseTranslation'

import ColorCodeOption from './ColorCodeOption'
import ColorCodeEditor from './ColorCodeEditor'

import './ColorCodeManager.scss'

interface Props {
  show: boolean
  onHide: () => void
  onSelect: (colorCode: any) => void
}

const ColorCodeManager = ({ show, onHide, onSelect }: Props) => {

  const  { t } = useTranslation()

  const { itemOpened } = useProgrammation()

  const colorCodes = useSelector((state: any) => state.ProgrammationReducer.colorCodes)

  const [ showEditor, setShowEditor ] = useState(false)

  const [ colorCode, setColorCode ] = useState(null)

  const handleEditColorCode = (colorCode: any) => {
    setColorCode(colorCode)
    setShowEditor(true)
  }

  return (
    <Fragment>
      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        size="sm"
        backdropClassName='color-code-manager-backdrop'
        className='color-code-manager'
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('COLOR_CODE_SELECTOR:Title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='color-code-manager-scrollable custom-scrollbar'>
          <div>
            <ListGroup>
              {colorCodes?.map((colorCode: any, i: number) => (
                <Dropdown.Item
                  key={i} as={ColorCodeOption}
                  name={colorCode.name}
                  color={colorCode.color}
                  selected={itemOpened.colorCode && itemOpened.colorCode.name === colorCode.name}
                  onClick={() => onSelect(colorCode)}
                  onEdit={(e: any) => handleEditColorCode(colorCode)}
                />
              ))}
            </ListGroup>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
              {t('COLOR_CODE_SELECTOR:CloseButton')}
            </Button>
            <Button variant="primary" onClick={() => setShowEditor(true)}>
              {t('COLOR_CODE_SELECTOR:AddButton')}
            </Button>
        </Modal.Footer>
      </Modal>

      <ColorCodeEditor
        show={showEditor}
        colorCode={colorCode}
        onHide={() => {

          setShowEditor(false)
          setColorCode(null)
        }}
      />
    </Fragment>
  )
}

export default ColorCodeManager
